@if (url()) {
  <div
    [class]="getProjectAvatarSize()"
    class="relative rounded-md overflow-hidden"
  >
    <img
      [class]="getProjectAvatarSize()"
      [src]="url()"
      [alt]="projectName()"
      class="object-cover"
    />

    <div class="absolute inset-0 flex items-center justify-center">
      <span class="text-proffeo-on-action text-2xl font-semibold uppercase">
        {{ projectName()?.charAt(0) }}
      </span>
    </div>
  </div>
} @else {
  <div
    [class]="getProjectAvatarSize()"
    class="relative flex items-center justify-center rounded-md overflow-hidden project-avatar-fallback"
  >
    <div class="absolute inset-0 bg-cover bg-center blur-sm opacity-80"></div>
    <div class="absolute inset-0 bg-proffeo-base-900/70"></div>
    <span class="relative z-10 text-proffeo-on-action text-2xl font-semibold uppercase">
      {{ projectName()?.charAt(0) }}
    </span>
  </div>
}
